import React, { useState, useEffect } from 'react'
import { geometry2geoJson } from '../utils/location'
import VisitService from '../services/VisitService'
import FeatureMap from './FeatureMap'
import Header from './Header'
import { Box, Drawer } from '@material-ui/core';
import { useStore } from '../Store'
import BottomNavigationCustom from './BottomNavigationCustom';
import FeatureFilter from './FeatureFilter'

const FeaturesContainer = () => {
    const {year, featurePopup}= useStore()
    const initialFilter= {
        startSeasonId: year,
        stopSeasonId: year,
        isObserver: true
    }
    const [data, setData] = useState([])
    const [filter, setFilter] = useState(initialFilter)
    const [open, setOpen]= useState(false)

    let height = Math.round(window.innerHeight)

    useEffect(() => {
        const feature = (obs) => {
            const feat = {
                type: 'Feature',
                properties: { ...obs },
                geometry: geometry2geoJson(obs.geometry)
            }
            return feat;
        }
        VisitService.getFeatures(filter)
            .then(obs => {
                const geojson = obs.data.filter(o => o.geometry).map(o => feature(o))
                setData(geojson)
            })
    }, [filter])

    const openFilter= () => {
        setOpen(true)
    }

    const submitFilter= (filter) => {
        setFilter(filter)
        closeFilter()
    }

    const closeFilter= () => {
        setOpen(false)
    }


    return (
        <>
        <Box style={{height:'calc(100vh - 112px)'}}>
        <Drawer open={open}>
            <Header title={`Selectie waarnemingen`} />
                <FeatureFilter filter={filter} onSubmit={submitFilter} onCancel={closeFilter}  />
            <BottomNavigationCustom />
        </Drawer>
        <Header title={`Waarnemingen`} menuAction={openFilter} />
        <FeatureMap data={data} popup={featurePopup} height={height-120}/>
        <BottomNavigationCustom />
        </Box>
        </>
    )
}

export default FeaturesContainer
